import React from 'react';
import { NavLink } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

const navItems = [
  { to: '/calculator', label: 'Calculator', icon: '🧮' },
  { to: '/history', label: 'History', icon: '🕑' },
  { to: '/profile', label: 'Profile', icon: '👤' },
  { to: '/terms', label: 'Terms', icon: '📘' },
];

export function AppLayout({ children }: { children: React.ReactNode }) {
  const { user, signOut } = useAuth();

  return (
    <div className="app-layout">
      <aside className="app-sidebar">
        <div className="sidebar-brand">
          <img className="sidebar-logo" src="/deathestimate-logo.png" alt="Deathestimate" />
          <div>
            <p className="brand-title">Deathestimate</p>
            <p className="brand-caption">Web beta</p>
          </div>
        </div>
        <nav>
          {navItems.map(item => (
            <NavLink key={item.to} to={item.to} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              <span aria-hidden="true">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-pill">
            <span>{user?.email ?? 'Signed in user'}</span>
          </div>
          <button type="button" className="button-secondary" onClick={() => { void signOut(); }}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="app-content">{children}</main>
    </div>
  );
}
